import { useState } from "react";
import { API, openServerFile } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { PageHeader } from "@/components/shared";
import { F, In, Sel } from "@/pages/Feed";
import { FileSpreadsheet, FileText, FileDown, CalendarRange } from "lucide-react";
import { toast } from "sonner";

export default function Reports() {
  const { coops } = useApp();
  const activeCoops = coops.filter((c) => c.type === "coop");
  const [coopId, setCoopId] = useState("");
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const [month, setMonth] = useState(new Date().toISOString().slice(0, 7));
  const [monthCoop, setMonthCoop] = useState("");

  const download = async (format) => {
    const params = new URLSearchParams({ format, token: localStorage.getItem("token") || "" });
    if (coopId) params.set("coop_id", coopId);
    if (start) params.set("start", start);
    if (end) params.set("end", end);
    const url = `${API}/export/production?${params.toString()}`;
    const res = await openServerFile(url, `Üretim Raporu (${format.toUpperCase()})`);
    if (res === "opened") toast.success(`${format.toUpperCase()} raporu indiriliyor`);
  };

  const downloadMonthly = async () => {
    if (!month) return toast.error("Ay seçin");
    const params = new URLSearchParams({ month, token: localStorage.getItem("token") || "" });
    if (monthCoop) params.set("coop_id", monthCoop);
    const res = await openServerFile(`${API}/export/monthly?${params.toString()}`, "Aylık İcmal PDF");
    if (res === "opened") toast.success("Aylık icmal PDF indiriliyor");
  };

  const cards = [
    { format: "xlsx", label: "Excel (.xlsx)", desc: "Renkli başlıklı, formüllü çalışma sayfası", icon: FileSpreadsheet, tone: "text-green-600 bg-green-500/10", testid: "export-xlsx" },
    { format: "csv", label: "CSV", desc: "Diğer sistemlere aktarım için düz veri", icon: FileDown, tone: "text-sky-600 bg-sky-500/10", testid: "export-csv" },
    { format: "pdf", label: "PDF İcmal", desc: "Yazdırılabilir günlük/aylık icmal raporu", icon: FileText, tone: "text-red-600 bg-red-500/10", testid: "export-pdf" },
  ];

  return (
    <div>
      <PageHeader title="Raporlar & Dışa Aktarım" subtitle="Üretim icmallerini Excel, CSV veya PDF olarak dışa aktarın" />

      <div className="rounded-xl border border-border bg-card p-5 mb-6 grid grid-cols-1 sm:grid-cols-3 gap-4" data-testid="report-filters">
        <F label="Kümes (opsiyonel)"><Sel value={coopId} onChange={setCoopId} opts={activeCoops} testid="rp-coop" /></F>
        <F label="Başlangıç Tarihi"><In type="date" value={start} onChange={setStart} testid="rp-start" /></F>
        <F label="Bitiş Tarihi"><In type="date" value={end} onChange={setEnd} testid="rp-end" /></F>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {cards.map((c) => (
          <button key={c.format} onClick={() => download(c.format)} data-testid={c.testid}
            className="text-left rounded-xl border border-border bg-card p-6 hover:border-primary hover:shadow-sm transition-all group">
            <div className={`h-12 w-12 rounded-lg flex items-center justify-center ${c.tone} mb-4`}><c.icon size={24} /></div>
            <div className="font-head font-semibold text-lg">{c.label}</div>
            <div className="text-sm text-muted-foreground mt-1">{c.desc}</div>
            <div className="mt-4 text-sm font-medium text-primary group-hover:underline">İndir →</div>
          </button>
        ))}
      </div>

      <div className="mt-8 rounded-xl border border-border bg-card p-6" data-testid="monthly-report">
        <div className="flex items-center gap-2 mb-1">
          <CalendarRange size={20} className="text-primary" />
          <h3 className="font-head font-semibold text-lg">Aylık İcmal Raporu (PDF)</h3>
        </div>
        <p className="text-sm text-muted-foreground mb-5">Seçilen ay için üretim, boylama, fire ve sevkiyat özetini tek bir şık PDF raporu olarak indirin.</p>
        <div className="flex flex-wrap items-end gap-4">
          <div className="w-44">
            <F label="Ay">
              <input type="month" value={month} onChange={(e) => setMonth(e.target.value)} data-testid="monthly-month"
                className="h-9 w-full rounded-md border border-input bg-background px-2 text-sm focus:ring-2 focus:ring-primary outline-none" />
            </F>
          </div>
          <div className="w-56">
            <F label="Kümes (opsiyonel)"><Sel value={monthCoop} onChange={setMonthCoop} opts={activeCoops} testid="monthly-coop" /></F>
          </div>
          <button onClick={downloadMonthly} data-testid="monthly-download"
            className="h-9 inline-flex items-center gap-2 rounded-full bg-primary text-primary-foreground px-6 text-sm font-semibold hover:bg-primary/90 transition-colors">
            <FileText size={16} /> PDF İndir
          </button>
        </div>
      </div>
    </div>
  );
}
